export default __webpack_public_path__ + "static/media/fibre5.7b57eb48.jpeg";